// react-native-web/dist/exports/Button/index.jsを参考に実装
import React from 'react'
import { TouchableOpacity, Text, ColorPropType, StyleSheet } from 'react-native'
import { bool, func, string } from 'prop-types'
import { themeColor, white } from './_variables.scss'

const DefaultButton = (props) => {
  const { accessibilityLabel, color, disabled, onPress, title } = props

  return (
    <TouchableOpacity
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      disabled={disabled}
      onPress={onPress}
      style={[
        styles.button,
        color && { backgroundColor: color },
        disabled && styles.buttonDisabled
      ]}
    >
      <Text
        style={[styles.text, disabled && styles.textDisabled]}
      >
        {title}
      </Text>
    </TouchableOpacity>
  )
}

DefaultButton.propTypes = process.env.NODE_ENV !== 'production' ? {
  accessibilityLabel: string,
  color: ColorPropType,
  disabled: bool,
  onPress: func.isRequired,
  title: string.isRequired,
} : {}

const styles = StyleSheet.create({
  button: {
    backgroundColor: themeColor,
    borderRadius: 6,
    padding: 4,
  },
  text: {
    color: white,
    fontWeight: '500',
    padding: 8,
    textAlign: 'center',
    fontSize: 18,
  },
  buttonDisabled: {
    backgroundColor: '#dfdfdf',
  },
  textDisabled: {
    color: '#a1a1a1',
  },
})

export default DefaultButton
